import img1 from "../../assets/Images/Accounting/Journal Entries.png"
import img2 from "../../assets/Images/Accounting/Create Journal Entries.png"

export default function JournalEntries() {
    return (
        <section id="journal-entries" className="space-y-16">

            {/* HEADER / OVERVIEW (STANDARD PATTERN) */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    3. Journal Entries
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    Journal Entries record every financial transaction in EventFlow using
                    the double-entry accounting principle.
                </p>

                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        Journal Entries form the foundation of the accounting system. Each
                        transaction is recorded with at least one debit and one credit entry,
                        ensuring that total debits always equal total credits.
                    </p>
                </section>
            </section>

            {/* JOURNAL LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Journal Entries List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Journal Entries module is opened, a chronological list of
                        all accounting entries is displayed.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Date of transaction</li>
                        <li>Account name</li>
                        <li>Description of the entry</li>
                        <li>Debit amount</li>
                        <li>Credit amount</li>
                        <li>Reference type (Expense, Purchase, Receipt, etc.)</li>
                        <li>Actions (Edit, Delete)</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4 ">
                  <img src={img1} alt="" />
                </div>
            </section>

            {/* FILTERS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Filtering Journal Entries
                </h3>

                <p className="text-slate-600 mb-4">
                    The filter section allows users to narrow down journal entries based on
                    specific criteria.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Reference Type (Expense, Purchase, Receipt Voucher, etc.)</li>
                    <li>Account selection</li>
                    <li>Date range (Start & End date)</li>
                    <li>Search keyword</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Filtered results automatically update totals for Debit and Credit.
                </p>
            </section>

            {/* TOTALS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Debit & Credit Totals
                </h3>

                <p className="text-slate-600 mb-4">
                    At the top of the journal list, EventFlow displays aggregated totals.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Total Debit amount</li>
                    <li>Total Credit amount</li>
                    <li>Instant validation of accounting balance</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Any imbalance indicates incomplete or incorrect accounting entries.
                </p>
            </section>

            {/* EXPORT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Export & Printing Options
                </h3>

                <p className="text-slate-600 mb-4">
                    Journal entries can be exported or printed for audit and recordkeeping
                    purposes.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Print journal entries</li>
                    <li>Export to Excel</li>
                    <li>Export to PDF</li>
                </ul>
            </section>

            {/* CREATE JOURNAL */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Creating Journal Entries
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking <strong>Create Journal Entry</strong> opens the journal entry
                    form used to manually record transactions.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Date of entry</li>
                    <li>Account selection</li>
                    <li>Debit amount</li>
                    <li>Credit amount</li>
                    <li>Description</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Multiple rows can be added to a single journal entry to maintain
                    accounting balance.
                </p>

                <div className="rounded-lg p-4 mt-4">
                  <img src={img2} alt="" />
                </div>
            </section>

            {/* BALANCE RULE */}
            <section className="bg-red-50 border border-red-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2 text-red-700">
                    Accounting Balance Rule
                </h3>

                <p className="text-slate-600 mb-4">
                    EventFlow enforces strict accounting rules for journal entries.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Total Debit must equal Total Credit</li>
                    <li>Unbalanced entries cannot be saved</li>
                    <li>Balance indicator shows real-time difference</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Journal Entries Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Journal Entries provide a complete audit trail of all financial
                    activity. They directly power ledgers, trial balance, profit & loss,
                    and balance sheet reports, ensuring accounting accuracy and compliance.
                </p>
            </section>

        </section>
    );
}
